$(document).ready(function(){

    function ModuleSwitch(){
        var icoonBtn = $("#show-icoon");
        var lijstBtn = $("#show-lijst");
        var icoonweergave = $("#icoonweergave");
        var lijstweergave = $("#lijstweergave");

        icoonBtn.on('click',function(){
            lijstweergave.hide();
            icoonweergave.show();
            icoonBtn.addClass('active');
            lijstBtn.removeClass('active') ;
            icoonweergave.addClass('active') ;
            lijstweergave.removeClass('active') ;
            icoonweergave.css('display','flex');
        });

        lijstBtn.on('click', function(){
            icoonBtn.removeClass('active');
            lijstBtn.addClass('active') ;
            icoonweergave.hide();
            lijstweergave.show() ;
            lijstweergave.css('display','block');
            icoonweergave.removeClass('active') ;
            lijstweergave.addClass('active') ;

        });
    }

    function showElement(id)
    {
        $('#'+id).css('display', 'block');
    }

    function hideElement(id)
    {
        $('#'+id).css('display', 'none');
    }

    $("#showLess").on('click', function(){
        hideElement('text1') ;
        showElement('text0') ;
    }) ;

    $("#showMore").on('click', function(){
        showElement('text1') ;
        hideElement('text0') ;
    }) ;

    $("#showModuleBlock").on('click', function(){
        showElement('moreblocks') ;
        $('.showModuleHolder').hide();
    }) ;

    $("#hideModuleBlock").on('click', function(){
        hideElement('moreblocks') ;
    }) ;

    $(".button-module").on("click", function(){
        setModalContentAndShow($(this).data('title'), $(this).data('description'), $(this).data('imagesrc')) ;
    }) ;

    $(".button-aandeslag").on("click", function(){
        window.location= sLandingspaginaUrl+'?o='+$(this).data('organisationhash')+'&b='+$(this).data('blogid');
    }) ;

    function setModalContentAndShow(title, description, image){
        $('#modalCenter .modal-title h3').html(title) ;
        $('#modalCenter .modal-body ').html(description) ;
        $("#modalCenter .modal-image").attr("src",image);


        $('#modalCenter').modal('show') ;
    }

    ModuleSwitch();
});










